export default __webpack_public_path__ + "static/media/tender1.24c434fa.png";